import React from 'react';

import {
	useClassNames,
} from '@common';

import './Space.scss';

type alignment = 'vertical' | 'horizontal';

interface SpaceProps {
	gap?: string,
	centered?: boolean,
	className?: string,
	alignment?: alignment,
	children: React.ReactNode,
}

const Space = (props: SpaceProps) => {
	const {
		alignment = 'horizontal',
		centered = false,
		gap = '10px',
		className,
		children,
	} = props;

	const classes = useClassNames(
		'space',
		`gap-${gap}`,
		centered && 'centered',
		className,
		alignment,
	);

	return (
		<div className={classes}>
			{children}
		</div>
	);
}

const MemoisedSpace = React.memo(Space);

export {MemoisedSpace as Space};